export function syncFundsByVisibleTableKeys(funds, { includePreviousFund = false } = {}) {
  const visibleTableKeys = Array.from(
    new Set(
      Object.values(funds || {}).flatMap(fund =>
        Array.isArray(fund?.visibleTableKeys) ? fund.visibleTableKeys : []
      )
    )
  );

  Object.values(funds || {}).forEach(fund => {
    fund.fund_data = fund.fund_data || {};

    visibleTableKeys.forEach(tableKey => {
      fund.fund_data[tableKey] = fund.fund_data[tableKey] || [];

      if (includePreviousFund && fund.previous_fund) {
        fund.previous_fund.fund_data = fund.previous_fund.fund_data || {};
        fund.previous_fund.fund_data[tableKey] = fund.previous_fund.fund_data[tableKey] || [];
      }
    });
  });

  return visibleTableKeys;
}
